<template lang="pug">
.form-group(:class='{ "loading dawn-card": files && files[0] && files[0].active }')
  label.field-label(v-if='fieldLabel') {{ fieldLabel }}
    em.optional(v-if='!required && !hideOptional') &nbsp;- optional
    | &nbsp;&nbsp;
  upload-component(v-if='!noButton && buttonPosition === "top"'
                  :auto='true'
                  v-model='files'
                  :multiple='multiple'
                  :drop='true'
                  @input-file='inputFile'
                  ref='upload'
                  :button-label='buttonLabel'
                  v-bind='$props'
  )
  span.helptip-wrapper
    span.helptip-icon(v-if='helptipBody', :class='{ invisible: !showHelptipIcon }' @click='toggleHelp()')
      i(:class='[showHelp ? hideIcon : showIcon]')
    ed-input-tooltip(:class='{ "error-message" : error }'
                    v-if='helptipBody && showHelp || helptipBody && error'
                    :helptipHeader='helptipHeader'
                    :errorTip='error'
                    :helptipBody='helptipBody'
    )
  .dawn-file-list-wrapper
    .dawn-file-list(v-for='(file, index) in files'
                    :key='file.id'
                    :class='{ editing: isEditing(file), "list-only": noButton }'
    )
      //- span.dawn-file-ordering
        i.fal.fa-ellipsis-v
      span.dawn-file-icon(v-html='fileIcon(file.type)')
      a.small(v-if='noButton || (canOpenFile && file.path)' :href='file.path' :target='target || "_blank"' @click='(e) => $emit("open-file", {e, path: file.path, file})') {{ file.name }}
      input.file-upload-item-input(v-else
                                   @focus='toggleEdit(file)'
                                   @blur='toggleEdit(file)'
                                   v-focus.lazy='checkIndex(index)'
                                   v-model='file.name'
                                   :readonly='readonly'
      )
      span.dawn-file-size {{ formatBytes(file.size, 0) }}
      span.dawn-remove-file(v-if='!noButton' :disabled='file.readonly' @click.prevent='() => file.readonly || $refs.upload.remove(file)')
        i.fas.fa-times-circle
  upload-component(v-if='!noButton && buttonPosition === "bottom"'
                  :auto='true'
                  v-model='files'
                  :multiple='multiple'
                  :drop='true'
                  @input-file='inputFile'
                  ref='upload'
                  :button-label='buttonLabel'
                  v-bind='$props'
  )
  slot(name='additionalText')
</template>

<script>

import FileUploadComponent from './fileUploadComponent.vue'

export default {
  name: 'ed-upload',
  components: {
    'upload-component': FileUploadComponent
  },
  mixins: [FileUploadComponent],
  props: {
    target: String,
    disabled: Boolean,
    readonly: Boolean,
    postAction: {
      type: String,
      default() {
        return this.$parent.endpoint || this.$parent.$attrs.endpoint
      }
    },
    noButton: {
      type: Boolean,
      default: false
    },
    buttonPosition: {
      type: String,
      default: 'top'
    },
    uploadAuto: Boolean,
    fieldLabel: String,
    hideOptional: Boolean,
    buttonLabel: String,
    required: Boolean,
    multiple: Boolean,
    autofocus: Boolean,
    helptipHeader: String,
    helptipBody: String,
    showHelptipIcon: {
      type: Boolean,
      default: true
    },
    error: Boolean,
    data: Object,
    value: Array,
    canOpenFile: Boolean
  },
  data () {
    return {
      files: [],
      showHelp: false,
      showIcon: 'fas fa-question-circle',
      hideIcon: 'far fa-times-circle'
    }
  },
  directives: {
    focus: {
      inserted: function (el, binding) {
        if (binding.value) el.focus()
        else el.blur()
      },
      componentUpdated: function (el, binding) {
        if (binding.modifiers.lazy) {
          if (Boolean(binding.value) === Boolean(binding.oldValue)) {
            return
          }
        }
        if (binding.value) el.focus()
        else el.blur()
      }
    }
  },
  created() {
    if (this.value && this.value.length) {
      this.files = this.value
    }
  },
  methods: {
    toggleHelp () {
      this.showHelp = !this.showHelp
    },
    checkIndex (item) {
      /* if (item === 0) {
        return true
      } */
    },
    formatBytes (bytes, decimals) {
      if (bytes === 0) return '0 Bytes'
      var k = 1024
      var dm = decimals || 2
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    toggleEdit (item) {
      if (item.editing) {
        item.editing = false
      } else {
        item.editing = true
      }
    },
    isEditing (item) {
      return item.editing
    },
    inputFile (newFile, oldFile) {
      if (newFile && oldFile) {
        // update

        if (newFile.active && !oldFile.active) {
          // beforeSend
          // min size
          if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
            this.$refs.upload.update(newFile, { error: 'size' })
          }
        }

        if (newFile.progress !== oldFile.progress) {
          // progress
        }

        if (newFile.error && !oldFile.error) {
          // error
        }

        if (newFile.success && !oldFile.success) {
          // success
        }
      }

      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response && oldFile.response.id) {
          // $.ajax({
          //   type: 'DELETE',
          //   url: '/upload/delete?id=' + oldFile.response.id,
          // })
        }
      }

      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }

      let filteredFiles = this.filterValidAndErrorFiles(this.files)
      this.$emit('input', this.files, filteredFiles.valid, filteredFiles.withError)
    },
    filterValidAndErrorFiles(files) {
      let validFiles = []
      let invalidFiles = []

      let itemResponse = ''
      let uploadError = ''

      files.map(item => {
        uploadError = ''

        if (!item.success) {
          invalidFiles.push(item)
        } else if (item.success && item.response) {
          if (utils.json.valid(item.response)) {
            itemResponse = JSON.parse(item.response)
            uploadError = (itemResponse && itemResponse.uploadError) ? itemResponse.uploadError : ''
          }

          if (uploadError === '') {
            validFiles.push(item)
          } else {
            invalidFiles.push(item)
          }
        }
      })

      return {
        valid: validFiles,
        withError: invalidFiles
      }
    },
    fileIcon (type) {
      var icon
      var color
      switch (type) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/svg':
        case 'image/svg+xml':
        case 'image/tiff':
        case 'image/webp':
        case 'image/gif':
        case 'image/x-icon':
          icon = 'file-image'
          color = '#4598d9'
          break
        case 'application/pdf':
          icon = 'file-pdf'
          color = '#cb0404'
          break
        case 'video/x-msvideo':
        case 'video/mpeg':
        case 'video/ogg':
        case 'video/webm':
        case 'video/3gpp':
        case 'video/3gpp2':
        case 'video/mp4':
        case 'video/x-ms-wmv':
          icon = 'file-video'
          color = '#dd4a4a'
          break
        case 'audio/aac':
        case 'audio/midi':
        case 'audio/ogg':
        case 'audio/x-wav':
        case 'audio/webm':
        case 'audio/3gpp':
        case 'audio/3gpp2':
        case 'audio/mp3':
          icon = 'file-audio'
          color = '#ff8800'
          break
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
        case 'application/json':
        case 'application/typescript':
        case 'application/xhtml+xml':
          icon = 'file-code'
          color = '#62c14c'
          break
        case 'application/x-7z-compressed':
        case 'application/zip':
        case 'application/x-zip':
        case 'application/x-zip-compressed':
          icon = 'file-archive'
          color = '#acacac'
          break
        default:
          icon = 'file-alt'
          color = '#2591e5'
      }
      return '<i style="color:' + color + '" class="fas fa-' + icon + '"></i>'
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.form-group {
  &.full-width {
    .field-label {
      display: block;
      @include theme {
      border-bottom: 1px solid v(background-light);
      }
    }
  }
  em.optional {
    @include optional-label;
  }

  div.dawn-file-list:nth-child(even){
    @include theme {
    // background: v(background-light);
    // border-color: v(background-light);
    background: v(canvas);
    border-color: v(canvas);
    border-bottom-color: v(background);
    }

    &.editing {
      @include theme {
      border-color: v(tertiary-01);
      box-shadow: 0px 0px 0px 1px v(tertiary-01);
      }
      .dawn-file-ordering, .dawn-remove-file, .dawn-file-size {
        opacity: 0;
      }
    }
  }
  div.dawn-file-list:nth-child(odd) {
    @include theme {
    background: v(canvas);
    border-color: v(canvas);
    border-bottom-color: v(background);
    }

    &.editing {
      @include theme {
      border-color: v(tertiary-01);
      box-shadow: 0px 0px 0px 1px v(tertiary-01);
      }
      .dawn-file-ordering, .dawn-remove-file, .dawn-file-size {
        opacity: 0;
      }
    }
  }
}

.dawn-file-list {
  position: relative;
  @include theme {
  background: v(canvas);
  }
  border: $border-width-default solid;
  padding: .3rem .2rem;
  margin-bottom: 1px;

  &.list-only {
    .dawn-file-size {
      right: .5rem;
    }
  }
}

input.file-upload-item-input {
  background: transparent;
  border: none;
  display: inline-block;
  font-size: $font-size-xsmall;
  width: calc(100% - 8rem);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: text-bottom;

  &:focus {
    border: none;
    outline-width: 0;
    outline: none;
    @include theme {
    color: v(border);
    }
  }
}

.dawn-file-ordering {
  display: inline-block;
  opacity: .5;
  margin-right: .5rem;
}

.dawn-file-icon {
  display: inline-block;
  margin-right: .5rem;
}

.dawn-file-size {
  font-weight: 300;
  font-size: 0.65rem;
  display: block;
  position: absolute;
  right: 4rem;
  top: .55rem;
  text-align: right;
}

.dawn-remove-file {
  font-size: 0.85rem;
  display: block;
  position: absolute;
  right: 1rem;
  top: .45rem;
  text-align: right;
  @include theme {
  color: v(primary-05);
  }

  &:hover {
    @include theme {
    color: v(primary-03);
    }
    cursor: pointer;
  }
  &[disabled] {
    @include theme {
    color: v(border);
    }
    cursor: not-allowed;
  }
}

.helptip-icon {
  &:hover {
    cursor: pointer;
  }
}

.helptip-wrapper {
  display: inline-block;
  position: relative;
  background: transparent;

  .invisible {
    // display: none;
  }
}

.dawn-input-tooltip {
  top: -110%;
  width: 2600%;
  left: 230%;
}

</style>



// WEBPACK FOOTER //
// src/core/components/edUpload/index.vue